module.exports = __webpack_public_path__ + "static/img/表情包.1491e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10003/表情包.png
// module id = uMlB
// module chunks = 1